import DeliveryBySection from 'components/OrderConfirmation/SddSections/DeliveryBySection/DeliveryBySection';

export default DeliveryBySection;
